import { render, staticRenderFns } from "./RailsContent.vue?vue&type=template&id=a308349c&scoped=true&"
import script from "./RailsContent.vue?vue&type=script&lang=js&"
export * from "./RailsContent.vue?vue&type=script&lang=js&"
import style0 from "./RailsContent.vue?vue&type=style&index=0&id=a308349c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a308349c",
  null
  
)

export default component.exports